import { mapState } from 'pinia'
const gqls = require('@/gqls')
import { useStore } from '@/stores/index'

export const apollo = {
  data() {
    return {
      data: null
    }
  },
  computed: {
    ...mapState(useStore, ['language'])
  },
  apollo: {
    data: {
      query() {
        return gqls[this.apolloId]
      },
      variables() {
        return {
          'language': this.language
        }
      },
      // is a boolean to disable the automatic property update.
      // If you use it, you then need to specify a result callback
      // https://apollo.vuejs.org/api/smart-query.html#options
      manual: true,
      result({ data, loading }) {
        // Guard against `data` being undefined. Apollo still fires
        // `result()` when a query errors (backend unreachable, bad
        // env endpoint, GraphQL error, etc.), with `data` undefined.
        // Without this guard, `data[this.apolloId]` throws
        // "Cannot read properties of undefined" and white-screens the
        // app. Components consume `this.data` via optional chaining
        // (`data?.x`), so leaving it null renders an empty state
        // gracefully instead of crashing.
        if (!loading && data) {
          this.data = data[this.apolloId]
        }
      },
      error(error) {
        console.log(error)
      }
    }
  }
}
